export default __webpack_public_path__ + "static/media/getting-started.848b78dc.png";